module.exports = {"StatusCode":200,"Payload":[{"newCert":false}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/touchDomainRecord.json
// module id = OmzQ
// module chunks = 0